// This file is part of Coog. The COPYRIGHT file at the top level of
// this repository contains the full copyright notices and license terms.

export const CSS_UID = 'confirmation-173c9e28-e81d-4e13-a531-40038480ce4e';
